import HTTP_METHODS from "src/general/constants/http/httpMethods";
import {
	loyaltyProgramGetRequest as Req,
	loyaltyProgramGetResponse as Res,
} from "src/business.InterfaceLayer/store/entities/loyaltyProgram.entity/redux/api/types/POST";
import { createBaseQueryDefinition } from "src/business.InterfaceLayer/store/services/utils.service/ResponseTransforms";
import { ApiQueryBuilder } from "src/business.InterfaceLayer/store/types/ApiQueryBuilder.type";
import { Nullable } from "../../../../../types/Nullable.type";
import LEVELS_PATHS from "../../paths";
import MAIN_PATHS from "../../../../../mainPaths";

const postRequestBaseDefinition = createBaseQueryDefinition(
	HTTP_METHODS.POST,
	MAIN_PATHS.LOYALTY_PROGRAM
);

const loyaltyProgramApiPostQueries = (build: ApiQueryBuilder) => ({
	setPromoCode: build.mutation<
		Nullable<Res.SetPromoCodePost>,
		Req.SetPromoCodePost
	>({
		query: (body) => ({
			...postRequestBaseDefinition({
				path: LEVELS_PATHS.SET_PROMO_CODE,
			}),
			body,
		}),
	}),

	checkReferralCode: build.mutation<
        Nullable<Res.CheckReferralCodePost>,
        Req.CheckReferralCodePost
    >({
        query: (body) => ({
            ...postRequestBaseDefinition({
                path: LEVELS_PATHS.CHECK_REFERRAL_CODE,
            }),
            body,
        }),
    }),
});

export default loyaltyProgramApiPostQueries;
